import React from 'react';
import './TrueContraindications.css';

const TrueContraindications = () => {
  return (
    <div className="container trueContraindications">
      <h2>True Contraindications to Vaccine Administration</h2>
      <br />
      
      <table>
        <thead>
          <tr>
            <th>Safety Concern</th>
            <th>Reason for Contraindication and Recommended Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Previous anaphylactic reaction to a specific vaccine</td>
            <td>Avoid revaccination with the specific vaccine because of risk of recurrence.</td>
          </tr>
          <tr>
            <td>Previous anaphylactic reaction to neomycin or streptomycin</td>
            <td>
              Avoid measles, mumps, rubella (MMR) vaccine because the MMR vaccine contains trace amounts of
              neomycin.
            </td>
          </tr>
          <tr>
            <td>History of severe systemic reactions to the cholera, typhoid or plague vaccine</td>
            <td>Avoid revaccination with the specific vaccine because of risk of recurrence.</td>
          </tr>
          <tr>
            <td>Adults who are immunocompromised as a result of disease or its treatment</td>
            <td>
              Avoid live virus vaccines because there is an increased risk of viral replication in
              immunocompromised individuals. (Refer to UpToDate topics on immunizations in patients with cancer
              and transplant recipients.)
            </td>
          </tr>
          <tr>
            <td>Household members of immunocompromised patients</td>
            <td>
              Avoid oral polio because vaccine-induced disease (if it occurs) could be transmitted to the
              immunocompromised individual. This concern does not apply to the MMR vaccine because infection with
              vaccine strain measles, mumps, or rubella is not transmitted to others. (Refer to UpToDate topic on
              polio vaccination.)
            </td>
          </tr>
          <tr>
            <td>Pregnant women</td>
            <td>
              Avoid all live virus vaccines because of the potential risk to the fetus. (Refer to UpToDate topic
              on immunizations during pregnancy.)
            </td>
          </tr>
        </tbody>
      </table>

      <br />
      
      <footer>
        <p>
          <i>
            Data from: American College Physicians Task Force on Adult Immunization and Infectious Diseases
            Society of America. Guide for adult immunization. Philadelphia. American College of Physicians,
            1994; Centers for Disease Control and Prevention. MMWR Morb Mortal Wkly Rep 1994; 43:1; and Gershon,
            AA, Gardner, P, Peter, G, et al. Clin Infect Dis 1997; 25:782.
          </i>
        </p>
      </footer>
      
      <br />
     
      <footer>
        <p>Information sourced from uptodate.com</p>
      </footer>
    </div>
  );
};

export default TrueContraindications; 